import { createSlice } from "@reduxjs/toolkit";
import { logOut } from "../services/login-services";

const initialState = {
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const logoutSlice = createSlice({
  name: "logout",
  initialState,
  reducers: {
    resetLogout(state) {
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logOut.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(logOut.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
        state.loading = false;
      })
      .addCase(logOut.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const { resetLogout, resetState, resetError } = logoutSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default logoutSlice.reducer;
